import React from 'react';
import Facebook from '../images/facebook.svg';
import Twitter from '../images/twitter.svg';
import Email from '../images/email.svg';
import Locale from '../locales/en/footer';

const Footer = () => (
  <div id="footer">
    <div className="phone">
      <a href="tel:1-646-786-0888">
        {Locale.phone}
      </a>
    </div>
    <div className="social-media">
      <a href="mailto:info@cnycn.org">
        <img src={Email} alt="Email" />
      </a>
      <a href="https://www.facebook.com/cnycn" target="_blank" rel="noopener noreferrer">
        <img src={Facebook} alt="Facebook Logo" />
      </a>
      <a href="https://www.twitter.com/cnycn" target="_blank" rel="noopener noreferrer">
        <img src={Twitter} alt="Twitter Logo" />
      </a>
    </div>
    <div className="privacy">
      <a href="https://cnycn.org/privacy" target="_blank" rel="noopener noreferrer">
        {Locale.privacy}
      </a>
    </div>
    <div className="terms">
      <a href="https://cnycn.org/terms" target="_blank" rel="noopener noreferrer">
        {Locale.terms}
      </a>
    </div>
    <div className="column-left">
      <div className="phone">
        <a href="tel:1-646-786-0888">
          {Locale.phone}
        </a>
      </div>
      <div className="social-media-mobile">
        <a href="mailto:info@cnycn.org">
          <img src={Email} alt="Email" />
        </a>
        <a href="https://www.facebook.com/cnycn" target="_blank" rel="noopener noreferrer">
          <img src={Facebook} alt="Facebook Logo" />
        </a>
        <a href="https://www.twitter.com/cnycn" target="_blank" rel="noopener noreferrer">
          <img src={Twitter} alt="Twitter Logo" />
        </a>
      </div>
    </div>
    <div className="column-right">
      <div className="privacy">
        <a href="https://cnycn.org/privacy" target="_blank" rel="noopener noreferrer">
          {Locale.privacy}
        </a>
      </div>
      <div className="terms">
        <a href="https://cnycn.org/terms" target="_blank" rel="noopener noreferrer">
          {Locale.terms}
        </a>
      </div>
    </div>
  </div>
);

export default Footer;
